<div class="td-wb-simplified-list">
  <div class="td-wb-simplified-list__title">
    <ng-content select="[tdWbSimplifiedListTitle]" />
  </div>
  @if (items) {
    <ul class="td-wb-simplified-list__ul"
        [attr.aria-label]="ariaLabel()"
        [attr.aria-labelledby]="ariaLabelledBy()">
      @for (item of items; track item) {
        <ng-container [ngTemplateOutlet]="item.templateRef()" />
      }
    </ul>
  }
</div>
